/* eslint-disable */
const { lobby } = require('./lobby');
const { wiki } = require('./wiki');
const { game } = require('./game');
const { notFound } = require('./notFound');
const { roles } = require('./roles');
const { expansions } = require('./expansions');
const { lancelots } = require('./lancelots');
const { lady } = require('./lady');
const { ladySea } = require('./ladySea');
const { excalibur } = require('./excalibur');
const { morgana } = require('./morgana');
const { percival } = require('./percival');
const { rules } = require('./rules');
const { lovers } = require('./lovers');
const { merlin } = require('./merlin');
const { about } = require('./about');
const { oberon } = require('./oberon');
const { mordred } = require('./mordred');
const { troublemaker } = require('./troublemaker');
const { trickster } = require('./trickster');
const { witch } = require('./witch');
const { brute } = require('./brute');
const { lunatic } = require('./lunatic');
const { guinevere } = require('./guinevere');
const { minion } = require('./minion');
const { servant } = require('./servant');
const { merlinPure } = require('./merlinPure');
const { cleric } = require('./cleric');
const { revealer } = require('./revealer');
const { stats } = require('./stats');
const { profile } = require('./profile');
const { userStats } = require('./userStats');
const { plotCards } = require('./plotCards');
const { leaderboard } = require('./leaderboard');
const { globalAchievements } = require('./globalAchievements');
const { userAchievements } = require('./userAchievements');

const { support } = require('./support');
const { community } = require('./community');

module.exports = {
  community,
  support,
  lobby,
  wiki,
  game,
  notFound,
  roles,
  expansions,
  lancelots,
  lady,
  ladySea,
  excalibur,
  morgana,
  percival,
  rules,
  lovers,
  merlin,
  about,
  oberon,
  mordred,
  troublemaker,
  trickster,
  witch,
  brute,
  lunatic,
  guinevere,
  minion,
  servant,
  merlinPure,
  cleric,
  revealer,
  stats,
  profile,
  userStats,
  plotCards,
  leaderboard,
  globalAchievements,
  userAchievements,
};
